import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { Typography } from '@material-ui/core'
import React from 'react'

export interface ProductTypeAutocompleteOptionProps {
    option: string
}

export const ProductTypeAutocompleteOption = ({
    option,
}: ProductTypeAutocompleteOptionProps) => {
    const item = option?.split('%|%')
    const premiumPlusIndicatorIndex = 1
    const productTypeIdIndex = 2

    const productTypeId =
        item && item.length >= productTypeIdIndex && item[productTypeIdIndex]
            ? ` - ${item[productTypeIdIndex]}`
            : ''
    const premiumPlusProductIdentifier =
        item &&
        item.length >= premiumPlusIndicatorIndex &&
        item[premiumPlusIndicatorIndex] !== 'null'
            ? '(+) '
            : ''

    const productType = item && item.length > 0 ? item[0] : ''
    const tooltipText = `${productType}${productTypeId}`

    return (
        <HoverTooltip text={tooltipText}>
            <Typography style={{ width: '100%' }}>
                {premiumPlusProductIdentifier}
                {productType}
            </Typography>
        </HoverTooltip>
    )
}
